<app-text-field
  #textfield
  class="w-full"
  [placeholder]="placeholder | translate"
  [placeholderIcon]="'search'"
  [autoFocus]="autoFocus"
  [maxLength]="maxLength"
  [clearButtonEnabled]="clearButtonEnabled"
  [(ngModel)]="value">
</app-text-field>
